var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "d-md-none slide-popin-modal" },
      [
        _c(
          "slide-popin-modal-filter",
          {
            attrs: {
              id: "slide-filters-reviews-modal",
              "aria-labelledby": "slide-filters-reviews",
              "with-close-button": false,
            },
          },
          [
            _c("device-filter-reviews", {
              attrs: {
                device: "mobile",
                loading: _vm.deviceFilterReviews.loading,
                "reviews-messages": _vm.reviewsMessages,
                "ratings-filter-check-boxes": _vm.ratingsFilterCheckboxes,
              },
              on: {
                "change-check-box-ratings-filter":
                  _vm.updateRatingsFilterHandler,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 col-md-4 col-lg-3" }, [
      _c(
        "div",
        { staticClass: "d-none d-md-block" },
        [
          _c("device-filter-reviews", {
            attrs: {
              device: "desktop",
              loading: _vm.deviceFilterReviews.loading,
              "reviews-messages": _vm.reviewsMessages,
              "ratings-filter-check-boxes": _vm.ratingsFilterCheckboxes,
            },
            on: {
              "change-check-box-ratings-filter": _vm.updateRatingsFilterHandler,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-md-8 col-lg-9" },
      [
        _c("device-details-reviews", {
          attrs: {
            "reviews-total-number": _vm.deviceDetailsReviews.totalNumber,
            "device-reviews": _vm.deviceDetailsReviews.reviews,
            offset: _vm.deviceDetailsReviews.offset,
            "bloc-size": _vm.deviceDetailsReviews.blocSize,
            loading: _vm.deviceDetailsReviews.loading,
            "reviews-messages": _vm.reviewsMessages,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _vm.hasMoreReviews
        ? _c("div", { staticClass: "row text-center mt-1" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("ob1-boutons", {
                  attrs: {
                    "is-button": true,
                    label: _vm.reviewsMessages.more,
                    "is-secondary": true,
                  },
                  on: { "ob1-boutons-click": _vm.getMoreDeviceReviews },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }